import { useQuery } from '@tanstack/react-query';
import { useSearchAiPluginStore } from 'store/searchAiPluginStore';

export const useGetCustomization = () => {
    const { getCustomization } = useSearchAiPluginStore();
    return useQuery({
        queryKey: ['getCustomization'],
        queryFn: getCustomization,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
    });
};
